import { useQuery } from "@tanstack/react-query";
import { getReviewsList } from "../../api/bReviewsApi";

export const useGetReviewsList = (params, enabled = true) => {
  // Create a serializable query key that includes all filter values
  const queryKey = [
    "reviews-list",
    params?.organisationId,
    params?.locationIds?.join(',') || '',
    params?.startDate?.toISOString() || '',
    params?.endDate?.toISOString() || '',
    params?.sentiments?.join(',') || '',
    params?.ratings?.join(',') || '',
    params?.sources?.join(',') || '',
    params?.replied,
    params?.page,
    params?.pageSize
  ];

  return useQuery({
    queryKey,
    queryFn: () => getReviewsList(params),
    enabled: !!params?.organisationId && enabled,
    staleTime: 1000 * 60 * 2, // 2 minutes
    refetchOnWindowFocus: true,
  });
};
